

import { useSession } from '../../stores/session';
import { showVuePopup } from '../../utils/showVuePopup';
import Profile from '../../popup/Profile.vue';
import Register from '../../popup/Register.vue';
import Contact from '../../popup/Contact.vue';
import { useAuthStore } from '../../stores/auth';
import { storeToRefs } from 'pinia';
import WalletDeposit from '../../popup/WalletDeposit.vue';
import PromotionList from '../../popup/PromotionList.vue';
import AffiliateLink from '../../popup/AffiliateLink.vue';
import Login from '../../popup/Login.vue';

export default {
	name: 'Mobile',
	setup() {

		const auth = useAuthStore();
		auth.hydrate();

		const session = useSession();

		const btnClickProfile = async () => {
			session.set('navbar_primary', 'profile');
			await showVuePopup(Profile);
		}

		const btnClickRegister = async () => {
			await showVuePopup(Register, {}, {
				customClass: {
					popup: 'bg-[url(https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/bg-register.webp)] bg-size-[100%_100%] bg-center bg-transparent'
				}
			});
		}

		const btnClickGame = async () => {
			window.location.href = '/slot';
		}

		const btnClickContact = async () => {
			await showVuePopup(Contact, {}, {
				customClass: {
					closeButton: 'absolute top-0 right-0 size-8! -translate-y-1/3 translate-x-1/3 bg-gray-100 hover:bg-gray-300 shadow rounded-full justify-center! items-center!',
					popup: 'bg-[url(https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/bg-contact-02.webp)] bg-size-[100%_100%] bg-center bg-transparent',
					htmlContainer: 'min-h-[16rem]',
				}
			});
		}

		const btnClickWallet = async () => {
			session.set('navbar_primary', 'wallet');
			session.set('navbar_sub', 'wallet:deposit');
			await showVuePopup(WalletDeposit);
		}

		const btnClickPromotion = async () => {
			if (!auth.isLoggedIn) {
				await showVuePopup(Login, {}, {
					customClass: {
						popup: 'bg-[url(https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/bg-login-Mobile.webp)] bg-size-[120%_100%] md:bg-size-[100%_100%] bg-center bg-transparent',
					},
				});
				return;
			}

			window.location.href = '/promotion';

			// session.set('navbar_primary', 'promotion');
			// session.set('navbar_sub', 'promotion:list');
			// await showVuePopup(PromotionList);
		}

		const btnClickAffiliate = async () => {
			if (!auth.isLoggedIn) {
				await showVuePopup(Login, {}, {
					customClass: {
						popup: 'bg-[url(https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/bg-login-Mobile.webp)] bg-size-[120%_100%] md:bg-size-[100%_100%] bg-center bg-transparent',
					},
				});
				return;
			}

			session.set('navbar_primary', 'affiliate');
			session.set('navbar_sub', 'affiliate:detail');
			await showVuePopup(AffiliateLink);
		}

		const paths: string[] = [
			'/demo', '/recommended', '/slot', '/casino', '/poker',
			'/card', '/fishhunter', '/lotto', '/sport', '/keno',
			'/trade', '/cockfighting', '/eport',
		];

		const checkPaths = (): boolean => {
			const normalize = (path: string) => path.replace(/\/+$/, '');
			const currentPath = normalize(window.location.pathname);
			return paths.some(path => currentPath === normalize(path));
		};

		return {
			auth,
			btnClickProfile,
			btnClickRegister,
			btnClickGame,
			btnClickContact,
			btnClickWallet,
			btnClickPromotion,
			btnClickAffiliate,
			checkPaths,
		}
	},
}
